import { mapGetters, mapActions } from 'vuex'
import publisher from '@/api/publisher'
import file from '@/api/file'
import user from '@/api/user'
export default {
  data() {
    return {
      time: 60,
      timer: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherInfo: 'getPublisherInfo',
      publisherId: 'getPublisherId',
      domain: 'getDomain'
    })
  },
  mounted() {
    let { email, type } = this.$route.query
    this.email = email
    this.type = type
    let publisherId = 'imr'
    // if (!location.hostname.includes('192.168')) {
    //   publisherId = location.hostname.split('.')[0]
    // }
    this.getDomain()
    this.getPublisherInfo(publisherId)
  },
  methods: {
    ...mapActions([
      'updateLanguage',
      'updatePublisherId',
      'updatePublisherInfo',
      'updateDomain'
    ]),
    async getPublisherInfo(publisherId) {
      this.updatePublisherInfo(await publisher.query(publisherId))
      this.updatePublisherId(this.publisherInfo.id)
    },
    async getDomain() {
      const domain = await file.domain()
      this.updateDomain(domain)
    },
    async resend() {
      this.loading = true
      await user.resend(this.type, {
        email: this.email,
        publisherId: this.publisherId
      })
      this.timer = setInterval(() => {
        this.time--
        if (this.time < 0) {
          clearInterval(this.timer)
          this.timer = ''
          this.time = 60
          this.loading = false
        }
      }, 1000)
      this.$message.success({
        title: 'Success',
        content: 'Resend Successfully'
      })
    }
  }
}
